import React, { SetStateAction, useEffect, useMemo, useState } from "react";
import { RiSearchLine } from "react-icons/ri";
import { useNavigate } from "react-router-dom";
import BaseButton from "Components/Base/BaseButton";
import TableContainer from "Components/Base/BaseTable";
import {
  checkStatusCodeSuccess,
  DownloadLabel,
  notFound,
  pdfDownload,
  rupeeSymbol,
  Search,
} from "Components/constants/Common";
import { NewLabel } from "Components/constants/RepairOrderOpening";
import { toast } from "react-toastify";
import DeleteModal from "Components/Base/DeleteModal";
import { ROPOLabel } from "Components/constants/RoPurchaseOrder";
import {
  deletePO,
  getViewPO,
  listOfPO,
  POPdfApi,
  updatePOStatus,
} from "Api/RoPurchaseOrder";
import BaseModal from "Components/Base/BaseModal";
import {
  NoLabel,
  POPublishLabel,
  StatusLabel,
  YesLabel,
} from "Components/constants/Role";
import { ROReturnLabels } from "Components/constants/ReturnRONPO";
import BasePanel from "Components/Base/BasePanel";
import {
  AddGRNLabel,
  GRN_STATUS_LABEL,
  PurchaseOrderLabel,
  PurchaseOrderOptions,
  VendorIdLabel,
  VendorNameLabel,
} from "Components/constants/PurchaseOrder";
import {
  ACTION_LABEL,
  AMOUNT_LABEL,
  PENDING_QTY_LABEL,
  PO_DETAILS_LABEL,
  PO_NO_LABEL,
  PR_NO_LABEL,
  PRODUCT_CODE_LABEL,
  RECEIVED_QTY_LABEL,
  RO_NO_LABEL,
  TOTAL_AMOUNT_LABEL,
  TOTAL_QTY_LABEL,
  VENDOR_ID_LABEL,
  VENDOR_NAME_LABEL,
} from "Components/constants/ROModule";
import Loader from "Components/Base/BaseLoader";
interface GRNHistoryItem {
  id: number;
  ro_po_id: number;
  product_id: number;
  received_quantity: number;
  pending_quantity: number;
  version: number;
  product: {
    id: number;
    product_code: string;
  };
}

interface PanelDataProps {
  id: number;
  part_id: number;
  vendor_id: number;
  user_draft_id: string;
  po_no: string;
  type: string;
  status: string;
  total_amount: number;
  po_status: string;
  grnHistory: GRNHistoryItem[];
  delivery_date: string;
  createdAt: string;
  total_cost?: string;
  out_standing_amount?: number;
  store_id: number;
  isGrn?: boolean;
  authUser: {
    id: number;
    name: string;
    user_draft_id?: string;
  };
  vendor: {
    id: number;
    name: string;
  };
  indent_draft_id: string;
  purchaseOrderItem: PurchaseOrderItem[];
}

interface PurchaseOrderItem {
  id: number;
  product_quantity: number;
  received_quantity: number;
  quantity: number;
  product: {
    id: number;
    product_code: string;
  };
}
let totalCost = 0;

const RoPurchaseOrder = () => {
  const [loader, setLoader] = useState<boolean>(false);
  const [ROO, setROO] = useState<any[]>([]);
  const [searchValue, setSearchValue] = useState<string>("");
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [limit, setLimit] = useState<number>(10);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [totalNumberOfRows, setTotalNumberOfRows] = useState<number>(0);
  const navigate = useNavigate();
  const [btnLoader, setBtnLoader] = useState<boolean>(false);
  const [deleteModal, setDeleteModal] = useState<boolean>(false);
  const [sortOrder, setSortOrder] = useState<string>("desc");
  const [ROOSearchData, setROOSearchData] = useState<Array<any>>([]);
  const [selectedROOId, setSelectedROOId] = useState<number | null>(null);
  const [columnName, setColumnName] = useState<string>("id");
  const [publishModalOpen, setPublishModalOpen] = useState<boolean>(false);
  const [panel, setPanel] = useState(false);
  const [panelId, setPanelId] = useState<number>();
  const [panelData, setPanelData] = useState<PanelDataProps>();
  const [requiredQty, setRequiredQty] = useState<number[]>([]);
  const [prodCode, setProdCode] = useState<string[]>([]);
  const [pageLoader, setPageLoader] = useState<boolean>(false);

  const handleFetchData = (page: any) => {
    setCurrentPage(page);
  };

  const openDeleteModal = (poid: number) => {
    setSelectedROOId(poid);
    setDeleteModal(true);
  };

  const closeDeleteModal = () => {
    setDeleteModal(false);
    setSelectedROOId(null);
  };
  const openDrawer = (state: boolean, data: any) => {
    setPanel(state);
    setPanelId(data?.id);
  };
  const handleFetchSorting = (
    page: any,
    id: SetStateAction<string>,
    order: SetStateAction<string>
  ) => {
    setCurrentPage(page);
    setColumnName(id);
    setSortOrder(order);
  };

  const fetchROOList = async () => {
    const payload = {
      limit,
      page: currentPage,
      sortKey: columnName,
      sortValue: sortOrder,
    };
    setLoader(true);
    listOfPO(payload)
      .then((res) => {
        if (checkStatusCodeSuccess(res?.statusCode)) {
          const flattenedData = res?.data?.purchaseOrder;
          setROO(flattenedData);
          setTotalRecords(res?.data?.totalItems || 0);
          setTotalPages(res?.data?.totalPages);
          setCurrentPage(res?.data?.currentPage);
          setTotalNumberOfRows(res?.data?.numberOfRows);
        } else {
          setROO([]);
        }
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message || err?.message);
      })
      .finally(() => setLoader(false));
  };

  const handleDeleteROO = () => {
    if (selectedROOId !== null) {
      setBtnLoader(true);

      deletePO(selectedROOId)
        .then((res) => {
          if (checkStatusCodeSuccess(res?.statusCode)) {
            toast.success(res?.message);
            fetchROOList();
          } else {
            toast.error(res?.message);
          }
        })
        .catch((error) => {
          toast.error(error?.response?.data?.message || error?.message);
        })
        .finally(() => {
          setBtnLoader(false);
          closeDeleteModal();
        });
    } else {
      setBtnLoader(false);
    }
  };

  const handleUpdatePOStatus = () => {
    if (selectedROOId !== null) {
      setBtnLoader(true);

      updatePOStatus(selectedROOId)
        .then((res) => {
          if (checkStatusCodeSuccess(res?.statusCode)) {
            toast.success(res?.message);
            fetchROOList();
          } else {
            toast.error(res?.message);
          }
        })
        .catch((error) => {
          toast.error(error?.response?.data?.message || error?.message);
        })
        .finally(() => {
          setBtnLoader(false);
          closePublishModal();
        });
    } else {
      setBtnLoader(false);
    }
  };

  const openPublishModal = (poid: number) => {
    setSelectedROOId(poid);
    setPublishModalOpen(true);
  };

  const closePublishModal = () => {
    setPublishModalOpen(false);
    setSelectedROOId(null);
  };

  const fetchSearchROOData = () => {
    const payload = {
      limit,
      page: currentPage,
      search: searchValue,
      sortKey: columnName,
      sortValue: sortOrder,
    };
    setLoader(true);
    listOfPO(payload)
      .then((response) => {
        if (checkStatusCodeSuccess(response.statusCode)) {
          const flattenedData = response?.data?.purchaseOrder;
          setROOSearchData(flattenedData);
          setTotalRecords(response?.data?.totalItems || 0);
          setTotalPages(response?.data?.totalPages);
          setCurrentPage(response?.data?.currentPage);
          setTotalNumberOfRows(response?.data?.numberOfRows);
          toast.success(response?.message);
        } else {
          setROOSearchData([]);
        }
      })
      .catch((error) => {
        setROOSearchData([]);
      })
      .finally(() => {
        setLoader(false);
      });
  };
  const handleDownload = (row: any) => {
    pdfDownload(
      POPdfApi,
      row?.id,
      `purhcase_order_${row?.po_no}.pdf`,
      setPageLoader
    );
  };
  useEffect(() => {
    if (panelId) {
      setLoader(true);
      getViewPO(panelId)
        .then((resp) => {
          if (checkStatusCodeSuccess(resp?.statusCode)) {
            setPanelData(resp?.data);
            const requiredQuantities =
              resp?.data?.repairOrderPurchaseOrderItem?.map(
                (item: { required_quantity: any }) => item.required_quantity
              );

            setRequiredQty(requiredQuantities);

            const productCodes = resp?.data?.repairOrderPurchaseOrderItem?.map(
              (item: { product: { product_code: string } }) =>
                item.product.product_code
            );
            setProdCode(productCodes);

            setPanelData(resp?.data);
            let resultArray: number[] = [];
            resp?.data?.purchaseOrderItem?.reduce((acc: number, value: any) => {
              const amount =
                Number(value?.rate) * Number(value?.product_quantity);
              const tax = value?.tax?.toString().split("_")?.[0];
              const taxAmount = (amount * tax) / 100;
              const finalAmount = amount + taxAmount;
              resultArray.push(finalAmount);
              return finalAmount;
            }, 0);
            let total_cost = resultArray?.reduce((acc, val) => {
              return (acc += val);
            }, 0);
            totalCost = total_cost;
          }
        })
        .catch((err) => {
          return err;
        })
        .finally(() => setLoader(false));
    }
  }, [panelId]);

  useEffect(() => {
    if (searchValue) {
      fetchSearchROOData();
    } else {
      fetchROOList();
    }
  }, [currentPage, limit, searchValue, sortOrder, columnName]);

  const repairOrderColumns = useMemo(
    () => [
      {
        header: RO_NO_LABEL,
        accessorKey: "repairOrder.ro_no",
        enableSorting: true,
        enableColumnFilter: false,
      },
      {
        header: PR_NO_LABEL,
        accessorKey: "partRequisition.pr_no",
        enableSorting: true,
        enableColumnFilter: false,
      },
      {
        header: PO_NO_LABEL,
        accessorKey: "po_no",
        enableSorting: true,
        enableColumnFilter: false,
      },
      {
        header: VENDOR_NAME_LABEL,
        accessorKey: "vendor.name",
        enableSorting: true,
        enableColumnFilter: false,
      },
      {
        header: VENDOR_ID_LABEL,
        accessorKey: "user_draft_id",
        enableSorting: true,
        enableColumnFilter: false,
      },
      {
        header: AMOUNT_LABEL,
        accessorKey: "total_amount",
        enableSorting: true,
        enableColumnFilter: false,
        cell: (cell: any) => {
          return rupeeSymbol(cell?.row?.original?.total_amount);
        },
      },
      {
        header: ACTION_LABEL,
        accessorKey: "action",
        cell: (cell: any) => {
          const { type } = cell?.row?.original;
          const isPublish = type === "Publish";
          return (
            <div className="d-flex justify-content-start enable-action gap-2 icon">
              <span className="tooltip-container">
                <i
                  className={`mdi mdi-download-outline fs-4 text-primary cursor-pointer`}
                  onClick={() => handleDownload(cell?.row?.original)}
                ></i>
                <span className="tooltip-text">{DownloadLabel}</span>
              </span>
              <span className="tooltip-container">
                <i
                  className={`mdi mdi-eye-outline fs-4 text-warning cursor-pointer`}
                  onClick={() => {
                    navigate(
                      `/viewRoPurchaseOrder/${cell?.row?.original?.id}`,
                      {
                        state: { viewQuotation: true },
                      }
                    );
                  }}
                ></i>
                <span className="tooltip-text">{ROReturnLabels.View}</span>
              </span>
              <span className="tooltip-container">
                <i
                  className={`mdi mdi-pencil-outline fs-4 text-info cursor-pointer ${
                    isPublish ? "disabled" : ""
                  }`}
                  onClick={() =>
                    !isPublish &&
                    navigate(`/editRoPurchaseOrder/${cell?.row?.original?.id}`)
                  }
                  style={
                    isPublish ? { pointerEvents: "none", opacity: 0.5 } : {}
                  }
                ></i>
                <span className="tooltip-text">{ROReturnLabels.Edit}</span>
              </span>

              <span className="tooltip-container">
                <i
                  className={`mdi mdi-delete-outline fs-4 text-danger cursor-pointer ${
                    isPublish ? "disabled" : ""
                  }`}
                  onClick={() =>
                    !isPublish && openDeleteModal(cell?.row?.original?.id)
                  }
                  style={
                    isPublish ? { pointerEvents: "none", opacity: 0.5 } : {}
                  }
                ></i>
                <span className="tooltip-text">{ROReturnLabels.Delete}</span>
              </span>
              <span className="tooltip-container">
                <i
                  className={`mdi mdi-check fs-4 cursor-pointer text-success ${
                    isPublish ? "disabled" : ""
                  }`}
                  onClick={() =>
                    !isPublish && openPublishModal(cell?.row?.original?.id)
                  }
                  style={
                    isPublish ? { pointerEvents: "none", opacity: 0.5 } : {}
                  }
                ></i>
                <span className="tooltip-text">{ROReturnLabels.Publish}</span>
              </span>
            </div>
          );
        },
        enableColumnFilter: false,
        enableSorting: false,
      },
    ],
    []
  );

  document.title = ROPOLabel;

  return (
    <div className="page-content">
      {pageLoader && <Loader />}
      <div className="flex-grow-1 mx-3">
        <div className="mb-1 mx-2 d-flex justify-content-between align-items-center">
          <span className="fs-4 d-flex gap-4">{ROPOLabel}</span>
          <div className="d-flex align-items-center gap-2">
            <BaseButton
              className="btn btn-success"
              onClick={() => navigate("/addRoPurchaseOrder")}
              children={
                <>
                  <i className="mdi mdi-plus" /> {NewLabel}
                </>
              }
            />
          </div>
        </div>

        <div className="card py-2 px-4 overflow-x-auto">
          {loader || ROO.length > 0 || ROOSearchData.length > 0 ? (
            <TableContainer
              customPageSize={limit}
              setCustomPageSize={setLimit}
              isGlobalFilter={true}
              columns={repairOrderColumns}
              data={searchValue ? ROOSearchData : ROO || []}
              tableClass="table bg-white"
              manualPagination={true}
              manualFiltering={true}
              tableLoader={loader}
              hasManualPagination={true}
              SearchPlaceholder={Search}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              setDrawerOpen={openDrawer}
              totalPages={totalPages}
              totalRecords={totalRecords}
              totalNumberOfRows={totalNumberOfRows}
              onSearch={setSearchValue}
              fetchData={handleFetchData}
              fetchSortingData={handleFetchSorting}
            />
          ) : (
            <div className="py-4 text-center">
              <div>
                <span className="fs-1 text-success">
                  <RiSearchLine />
                </span>
              </div>
              <div className="mt-4">
                <h5>{notFound.dataNotFound}</h5>
                <p className="text-muted">{notFound.thereIsNoDataFound}</p>
              </div>
            </div>
          )}

          <DeleteModal
            show={deleteModal}
            onCloseClick={closeDeleteModal}
            onDeleteClick={handleDeleteROO}
            btnLoader={btnLoader}
          />

          <BaseModal
            open={publishModalOpen}
            toggle={closePublishModal}
            submit={handleUpdatePOStatus}
            title={StatusLabel}
            submitLabel={YesLabel}
            submitLabelColor="success"
            loader={btnLoader}
            closeLabel={NoLabel}
            closeLabelColor="danger"
          >
            <>
              <div>{POPublishLabel}</div>
            </>
          </BaseModal>
        </div>
        <BasePanel
          isOpen={panel}
          onClose={() => setPanel(!panel)}
          size="650px"
          position="end"
          loader={loader}
          title={`${PurchaseOrderLabel} ${panelData?.po_no || ""}`}
          children={
            <>
              <div>
                <div className="container-fluid d-flex flex-column">
                  <div className="d-flex justify-content-end align-items-center gap-2 pb-2">
                    {panelData?.type === "Publish" &&
                      (panelData?.po_status === PurchaseOrderOptions.PENDING ||
                        panelData?.po_status ===
                          PurchaseOrderOptions.PARTIALLY_RECEIVED) && (
                        <BaseButton
                          className="btn btn-success py-1 px-2"
                          onClick={() =>
                            navigate(`/add-ro-grn/${panelData?.id}`)
                          }
                        >
                          {AddGRNLabel}
                        </BaseButton>
                      )}
                  </div>
                </div>
                <div className="flex-grow-1">
                  <div className="bg-white my-2">
                    <span className="fw-bold">{PO_DETAILS_LABEL}</span>
                  </div>
                  <div className="list-group list-group-flush">
                    <div className="list-group-item d-flex justify-content-between align-items-center">
                      <div className="col-3">
                        <b>{VendorIdLabel}</b>
                      </div>
                      <div className="col-2 text-dark">
                        {panelData?.user_draft_id || notFound.nullData}
                      </div>
                      <div className="col-4">
                        <b>{VendorNameLabel}</b>
                      </div>
                      <div className="col-3 text-dark">
                        {String(panelData?.vendor?.name)}
                      </div>
                    </div>

                    <div className="list-group-item d-flex justify-content-between align-items-center">
                      <div
                        className={
                          panelData?.po_status ===
                          PurchaseOrderOptions.PARTIALLY_RECEIVED
                            ? "col-2"
                            : "col-3"
                        }
                      >
                        <b>{GRN_STATUS_LABEL}</b>
                      </div>
                      <div
                        className={
                          panelData?.po_status ===
                          PurchaseOrderOptions.PARTIALLY_RECEIVED
                            ? "col-3"
                            : "col-2"
                        }
                      >
                        <span
                          className={
                            panelData?.po_status ===
                            PurchaseOrderOptions.RECEIVED
                              ? "badge bg-success"
                              : panelData?.po_status ===
                                PurchaseOrderOptions.PARTIALLY_RECEIVED
                              ? "badge bg-primary"
                              : "badge bg-info"
                          }
                        >
                          {panelData?.po_status || notFound.nullData}
                        </span>
                      </div>
                      <div className="col-4">
                        <b>{TOTAL_AMOUNT_LABEL}</b>
                      </div>
                      <div className="col-3 text-dark">
                        <i className="mdi mdi-currency-rupee"></i>
                        {panelData?.total_amount?.toFixed(2) || "0.00"}
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-7">
                      <table className="table table-bordered">
                        <thead className="border bg-light">
                          <tr>
                            <th>{PRODUCT_CODE_LABEL}</th>
                            <th>{TOTAL_QTY_LABEL}</th>
                            <th>{RECEIVED_QTY_LABEL}</th>
                            <th>{PENDING_QTY_LABEL}</th>
                          </tr>
                        </thead>
                        <tbody>
                          {panelData?.grnHistory?.length! > 0
                            ? panelData!.grnHistory.map(
                                (item: GRNHistoryItem) => (
                                  <tr key={item.id}>
                                    <td>
                                      {item.product?.product_code ||
                                        notFound.nullData}
                                    </td>
                                    <td>
                                      {item.received_quantity +
                                        item.pending_quantity ===
                                      0
                                        ? 0
                                        : item.received_quantity +
                                            item.pending_quantity ||
                                          requiredQty}
                                    </td>
                                    <td>{item.received_quantity || "0"}</td>
                                    <td>{item.pending_quantity || "0"}</td>
                                  </tr>
                                )
                              )
                            : prodCode?.map((code: string, index: number) => (
                                <tr key={index}>
                                  <td>{code || notFound.nullData}</td>
                                  <td>{requiredQty[index] || "0"}</td>
                                  <td>0</td>
                                  <td>{requiredQty[index] || "0"}</td>
                                </tr>
                              ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </>
          }
        />
      </div>
    </div>
  );
};

export default RoPurchaseOrder;
